import React from 'react';
import { Badge } from '../../components/ui/Badge';
import type { CostTier } from '../../api/ai-settings';
import { TIER_LABEL, TIER_VARIANT } from './format';

/** The model's cost label, worked out by the backend from its price. */
export const TierBadge: React.FC<{ tier: CostTier | null | undefined }> = ({ tier }) =>
  tier ? <Badge variant={TIER_VARIANT[tier]}>{TIER_LABEL[tier]}</Badge> : null;
